import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createEvent } from "../api";
import { TextField, Button, Typography, Container, Paper } from "@mui/material";

const NewEvent = () => {
    const navigate = useNavigate();
    const [eventName, setEventName] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventUrl, setEventUrl] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const newEvent = await createEvent(eventName, eventDate);
            const eventLink = `${window.location.origin}/events/${newEvent.eventId}`;
            setEventUrl(eventLink);
        } catch (error) {
            console.error("❌ イベント作成エラー:", error);
            alert("イベント作成に失敗しました");
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} style={{ padding: "20px", marginTop: "20px" }}>
                <Typography variant="h4" gutterBottom>新しいイベントを作成</Typography>
                <form onSubmit={handleSubmit}>
                    <TextField 
                        label="イベント名" 
                        fullWidth 
                        value={eventName} 
                        onChange={(e) => setEventName(e.target.value)} 
                        required 
                        margin="normal"
                    />
                    <TextField 
                        label="日付" 
                        type="date" 
                        fullWidth 
                        InputLabelProps={{ shrink: true }} 
                        value={eventDate} 
                        onChange={(e) => setEventDate(e.target.value)} 
                        required 
                        margin="normal"
                    />
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        イベントを作成
                    </Button>
                </form>

                {eventUrl && (
                    <div style={{ marginTop: "20px" }}>
                        <Typography variant="h6">イベントURL</Typography>
                        <TextField fullWidth value={eventUrl} readOnly />
                        <Button 
                            variant="outlined" 
                            color="secondary" 
                            fullWidth 
                            onClick={() => navigator.clipboard.writeText(eventUrl)}
                        >
                            コピー
                        </Button>
                        {/* ✅ 新しいタブで開くボタンを追加 */}
                        <Button 
                            variant="contained" 
                            color="success" 
                            fullWidth 
                            style={{ marginTop: "10px" }}
                            onClick={() => window.open(eventUrl, "_blank")}
                        >
                            新しいタブで開く
                        </Button>
                    </div>
                )}
            </Paper>
        </Container>
    );
};

export default NewEvent;
